import { useState, useCallback } from "react";
import { GameState } from "../core/GameState";
import type { TubeConfig, TrialConfig, HistoryEvent } from "../core/types";

export function useColorSort(
  initialTubes: TubeConfig[],
  undoEnabled = true,
  resetEnabled = true    // ← now accepts resetEnabled
) {
  const [game, setGame] = useState(() =>
    GameState.fromConfig({ tubes: initialTubes, undoEnabled } as TrialConfig)
  );

  const update = (fn: (gs: GameState) => void) => {
    const next = game.clone();
    fn(next);
    setGame(next);
  };

  const pour = useCallback(
    (from: number, to: number) => update(gs => gs.pour(from, to)),
    [game]
  );

  const undo = useCallback(() => {
    if (!undoEnabled) return;
    update(gs => gs.undo());
  }, [game, undoEnabled]);

  const reset = useCallback(() => {
    if (!resetEnabled) return;
    update(gs => gs.reset());
  }, [game, resetEnabled]);

  return {
    tubes:      game.tubes.map(t => ({ segments: t.segments })),
    moves:      game.history.length,
    canUndo:    undoEnabled && game.history.length > 0,
    canReset:   resetEnabled,
    isSolved:   game.isSolved(),
    events:     game.events as HistoryEvent[],
    pour,
    undo,
    reset,     // expose reset action
  };
}
